import {
  TransportHOCProps,
  TransportRef,
  TransportType,
} from "@/core/types/types";
import { AlternativeTransportationFlight } from "@/components/custom/AlternativeTransportation/Transportations/Flight/AlternativeTransportationFlight";
import AlternativeTransportationManual from "@/components/custom/AlternativeTransportation/Transportations/ManualTransports/AlternativeTransportationManual";
import { ComponentType, RefAttributes } from "react";
import { FieldProps } from "@/core/components/Field";

const transportComponents: {
  [key in TransportType]: ComponentType<
    RefAttributes<TransportRef> & FieldProps & TransportHOCProps
  >;
} = {
  [TransportType.bus]: AlternativeTransportationManual,
  [TransportType.train]: AlternativeTransportationManual,
  [TransportType.plane]: AlternativeTransportationFlight,
};

export default transportComponents;
